/**
 * Shared selection predicate for content painters (WI #5531).
 *
 * MapActivityBanner / MapActivityLabel both gate on "is this activity the active
 * selection (and we're not linking)". Kept in one place so the LabelsPainter and
 * BannerPainter agree byte-for-byte.
 */
import type { SceneContext } from '../../engine/SceneContext';
import type { MapActivity } from '@/store/ioStore';

export function isSelectedActivity(
  scene: SceneContext,
  activity: MapActivity,
): boolean {
  const { map } = scene;

  return (
    (map.selectedContext === 'activity' ||
      map.selectedContext === 'mirroredActivity') &&
    (map.selectedId === activity.id || map.selectedIds.includes(activity.id)) &&
    !map.isLinking
  );
}
